import React from "react";
import { connect, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { Mobile } from "../../../hocs/Responsive";
import { HelpPageNavigation } from "../HelpPageSidebar/HelpPageNavigation";
import { AppHeader } from "../../../components/layout/header/AppHeader";
import { MobileMenu } from "../../../components/mobileMenu/MobileMenu";
import { PortalTitle } from "../../../components/layout/portalTitle/PortalTitle";
import { getEulaHeaderHeight } from "../../../store/layout";
import { getHelp } from "../help.reducer";

import "./HelpHeader.scss";

const HelpHeaderComponent = ({ sections, businessName, logoLink }) => {
  const eulaHeaderHeight = useSelector(getEulaHeaderHeight);

  const { section } = useParams();

  return (
    <AppHeader
      className="header header--bordered help-header "
      style={{ top: `${eulaHeaderHeight}px` }}
    >
      <div className={"header__content layout__container"}>
        <PortalTitle title={businessName} link={logoLink} />
        <Mobile>
          <MobileMenu>
            {({ onToggleMenu }) => (
              <HelpPageNavigation
                className="help-header__navigation"
                sections={sections}
                activeSection={section}
                onToggleMenu={onToggleMenu}
                onItemClick={onToggleMenu}
              />
            )}
          </MobileMenu>
        </Mobile>
      </div>
    </AppHeader>
  );
};

export const HelpHeader = connect((state) => ({
  sections: getHelp(state).sections,
  businessName: state.accountSettings.businessName,
  logoLink: state.config.logoLink,
}))(HelpHeaderComponent);
